import useUser from '@hooks/auth/useUser';
import useDeepLinkListener from '@hooks/native/useDeepLinkListener';
import { useFlow } from '@router/stackflow';

function useDeepLink() {
    const { push } = useFlow();
    const { user } = useUser();
    useDeepLinkListener(({
        deepLinkType,
        shopId, noticeId, eventId,
    }) => {
        console.log(`deeplink ${deepLinkType}, ${JSON.stringify({
            shopId, noticeId, eventId,
        })}`);
        switch (deepLinkType) {
        case 'EVENT':
            if (eventId) {
                push('EventActivity', { eventId });
            }
            break;
        case 'NOTICE':
            if (noticeId) {
                push('NoticeActivity', { noticeId });
            }
            break;
        case 'COUPON_BOX':
            if (user) {
                push('CouponActivity', { type: 'MY' });
            } else {
                push('SignInActivity', {});
            }
            break;
        case 'STAMP':
            if (user) {
                push('StampsActivity', { });
            } else {
                push('SignInActivity', {});
            }
            break;
        case 'ITEMS':
            if (shopId) {
                push('ItemsActivity', { shopId, type: 'ALL' });
            }
            break;
        case 'GIFT_BOX':
            if (user) {
                push('GiftsActivity', { type: 'MAIN' });
            } else {
                push('SignInActivity', {});
            }
            break;
        case 'PREPAID_CARD':
            if (user) {
                push('MyPrepaidCardActivity', {});
            } else {
                push('SignInActivity', {});
            }
            break;
        default:
            console.log('딥링크');
        }
    }, [user]);
}

export default useDeepLink;
